import React from 'react';

interface CalculatorEmbedProps {
  file: string; 
}

const CalculatorEmbed: React.FC<CalculatorEmbedProps> = ({ file }) => {
  return (
    <div className="w-full h-[90vh]">
      <iframe
        title={file}
        src={`/calculators/${file}`}
        className="w-full h-full border-0 rounded-lg"
      />
    </div>
  );
};

export default CalculatorEmbed;
